import './MyCarouselTitle.css';
import './Homepage';

function MyCarouselTitle() {
    return (
        <div id="cloud_title" className="mt-5">
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <p class="chcTitle">#CLOUDYHAPPINESSCLUB</p>
            <br></br>
        </div>
    );
}

export default MyCarouselTitle;